export default function Go_if_else_Statement () {
  return (
    <div>
      <h1>Go_if_else_Statement </h1>
      <p>if else Statement</p>
    </div>
  );
}